export const resetDownloadButton = () => {
  // @ts-ignore
  document.getElementById("download").disabled = true
}

export const updateDownloadButton = () => {
  // @ts-ignore
  const downloadButton: HTMLButtonElement = document.getElementById("download")
  downloadButton.disabled = false
}

export const onDownloadButtonClicked = () => {
  const svgData = document.getElementById("svg")!.outerHTML
  const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" })
  const svgUrl = URL.createObjectURL(svgBlob)
  const downloadLink = document.createElement("a")
  downloadLink.href = svgUrl
  downloadLink.download = "caves.svg"
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}
